export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_complete_5.a46f61db.jpg";